import Vue from 'vue';
import Vuex from 'vuex';

import enums from './modules/enums';

import enumItems from './modules/enumItems';
import crud from './modules/crud';
import branches from './modules/branches';

import orders from './modules/orders';

import branchesConstraints from './modules/branchesConstraints';

import calendar from './modules/calendar';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {

    enums,

    enumItems,
    crud,
    branches,

    orders,

    branchesConstraints,

    calendar,
  },
});
